// extracted by mini-css-extract-plugin
module.exports = {"main":"discernAddress_main__39bUW","title":"discernAddress_title__RsirO","btn":"discernAddress_btn__1SL_E"};